//export const BASE_URL = 'https://localhost:44310/api';
// export const BASE_URL = 'http://localhost:8082/api';
export const BASE_URL = "https://sa360click2payapi.asce.org/api";
// export const BASE_URL ="https://sa360testclick2payapi.asce.org/api"
// export const BASE_URL = "https://sa360devclick2payapi.asce.org/api";
// export const JS_URL = "https://request.eprotect.vantivprelive.com/eProtect/js/eProtect-iframe-client3.min.js";
// export const JS_URL = "https://request.eprotect.vantivprelive.com/eProtect/js/eProtect-iframe-client4.min.js"
// export const JS_URL = "https://request.eprotect.vantivcnp.com/eProtect/js/eProtect-iframe-client3.min.js"
export const JS_URL = "https://request.eprotect.vantivcnp.com/eProtect/js/eProtect-iframe-client4.min.js";
